import React, { useState } from 'react';
import './navbar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faFileLines, faGrip, faHouse, faImage, faMessage, faUser, faXmark } from '@fortawesome/free-solid-svg-icons';
import portfolioData from '../../portfolio.json';

export default function Navbar() {
    const [Toggle, showMenu] = useState(false);
    const { header } = portfolioData;

    const getIcon = (iconName) => {
        switch (iconName) {
            case 'faHouse': return faHouse;
            case 'faUser': return faUser;
            case 'faFileLines': return faFileLines;
            case 'faBriefcase': return faBriefcase;
            case 'faImage': return faImage;
            case 'faMessage': return faMessage;
            default: return faHouse;
        }
    }

    return (
        <header>
            <nav className='nav container'>
                <a href='index.html' className='nav__logo'>{header.logo}</a>
                <div className={Toggle ? "nav__menu show-menu" : "nav__menu"}>
                    <ul className='nav__list grid'>
                        {header.nav.map((item, index) => (
                            <li className='nav__item' key={index}>
                                <a href={item.href} className={`nav__link ${index === 0 ? 'active-link' : ''}`}>
                                    <FontAwesomeIcon icon={getIcon(item.icon)} className='nav__icon' />  {item.name}
                                </a>
                            </li>
                        ))}
                    </ul>
                    <FontAwesomeIcon icon={faXmark} className='nav__close' onClick={() => showMenu(!Toggle)} />
                </div>
                <div className='nav__toggle' onClick={() => showMenu(!Toggle)}><FontAwesomeIcon icon={faGrip} /></div>
            </nav>
        </header>
    )
}
